module.exports = __webpack_public_path__ + "static/media/bse.acf88949.png";